import React, { useEffect, useState } from "react";
import { CardContent, Typography, Stack, Box, Avatar } from "@mui/material";
import EventBusy from "../../assets/images/event_busy.png";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import { useNavigate } from "react-router-dom";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken } from "../../utility/tokenUtility";
import axios from "axios";

function UnScheduledWorkOrder({ response }) {
  const navigate = useNavigate();
  const [unscheduledCount, setUnscheduledCount] = useState(0);

  const handleClick = () => {
    navigate("/workorder", {
      state: {
        tab: 2,
      },
    });
  };

  
    // useEffect(() => {
    //   const fetchData = async () => {
    //     try {
    //       const year = new Date().getFullYear();
    //       const month = new Date().getMonth() + 1; // Months are 0-indexed in JavaScript
    //       console.log("month", month);
    //       console.log("year", year);
    
    //       const token = getAuthToken("id_token");
    //       const config = {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //       };
    
    //       const departmentid =
    //         localStorage.getItem("roleName") === "DeptUser"
    //           ? 1
    //           : localStorage.getItem("roleName") === "Technician"
    //           ? 2
    //           : 0;
    //       const userid = localStorage.getItem("UserId");
    //       const facilityid = localStorage.getItem("facilityId"); // Ensure this exists
    
    //       if (!facilityid || !userid) {
    //         console.error("Missing facilityId or userId");
    //         return;
    //       }
    
    //       // Define API endpoints
    //       const apiUrlFEMS = `${FemsGraph}/api/Graphfemworkorder/GetWorkOrderCount/${facilityid}/${year}/${month}/${departmentid}/${userid}/${token}`;
    //       const apiUrlBEMS = `${BemsGraph}/api/Graphbemworkorder/GetWorkOrderCountsAsync/${facilityid}/${year}/${month}/${departmentid}/${userid}/${token}`;
    
    //       // Fetch data asynchronously
    //       const [responseFEMS, responseBEMS] = await Promise.all([
    //         axios.get(apiUrlFEMS, config),
    //         axios.get(apiUrlBEMS, config),
    //       ]);
    
    //       const femsCounts = responseFEMS.data || {
    //         totalCount: 0,
    //         scheduledCount: 0,
    //         unscheduledCount: 0,
    //         workrequestCount: 0,
    //         pdmscheduledCount: 0,
    //         rischeduledCount: 0,
    //       };
    
    //       const bemsCounts = responseBEMS.data || {
    //         totalCount: 0,
    //         scheduledCount: 0,
    //         unscheduledCount: 0,
    //         workrequestCount: 0,
    //         pdmscheduledCount: 0,
    //         rischeduledCount: 0,
    //       };
    
        
    //       const unscheduledCount =
    //         (femsCounts.unscheduledCount || 0) + (bemsCounts.unscheduledCount || 0);
    
    //       setUnscheduledCount(unscheduledCount);
    //     } catch (error) {
    //       console.error("Error fetching work order counts:", error);
    //     }
    //   };
    
    //   fetchData();
    // }, []); // Add dependencies if needed
  return (
    <>
      <StyledCard sx={{ cursor: "pointer" }}>
        <CardContent onClick={handleClick}>
          <Stack
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography mb={1.5} variant="h5" color={"text.primary"}>
                Unscheduled WO
              </Typography>
              <Typography m={0} variant="h1" color={"warning.dashboard"}>
              {/* {localStorage.getItem("roleName") === "Technician"
                  ? unscheduledCount
                  : response?.totalUnScheduledWorkOrderCount} */}
                  {response?.totalUnScheduledWorkOrderCount}
             
              </Typography>
            </Box>
            <Box bgcolor={"warning.dashboard"} p={1} borderRadius={50}>
              <Avatar
                alt="Remy Sharp"
                src={EventBusy}
                sx={{ width: 24, height: 24 }}
              ></Avatar>
            </Box>
          </Stack>
        </CardContent>
      </StyledCard>
    </>
  );
}

export default UnScheduledWorkOrder;
